module.exports = __webpack_public_path__ + "img/cac-pr3.43277312.svg";